import { RouteRecordRaw } from 'vue-router'

import {
  RESIDENCY_ROUTE_NAMES,
  RESIDENCY_ROUTE_NAMES_NEW,
} from '@/modules/residency/constants/ResidencyRouteNames'

import { UserGroup } from '@generated/types'

export const residencyRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/residency',
    name: RESIDENCY_ROUTE_NAMES.LIST,
    component: () => import('@/modules/residency/pages/ResidencyList.vue'),
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Residency',
    },
  },
  {
    path: '/venue/residency/:residencyId',
    name: RESIDENCY_ROUTE_NAMES.DETAIL,
    component: () => import('@/modules/residency/pages/ResidencyDetail.vue'),
    props: route => {
      const residencyId = route.params.residencyId
      return { residencyId: isNaN(Number(residencyId)) ? residencyId : Number(residencyId) }
    },
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Residency Detail',
      usesCustomNavbar: true,
    },
  },
  {
    path: '/venue/residency-new',
    name: RESIDENCY_ROUTE_NAMES_NEW.LIST,
    component: () => import('@/modules/residency/pages/ResidencyListNew.vue'),
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Residency List',
    },
  },
  {
    path: '/venue/residency-new/:residencyId',
    name: RESIDENCY_ROUTE_NAMES_NEW.DETAIL,
    component: () => import('@/modules/residency/pages/ResidencyDetailNew.vue'),
    props: route => {
      const residencyId = route.params.residencyId
      return { residencyId: isNaN(Number(residencyId)) ? residencyId : Number(residencyId) }
    },
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Residency Detail',
      usesCustomNavbar: true,
    },
  },
]
